import ScriptingEffect from './scripting/ScriptingEffect.js';
import {pipe} from './scripting/pipe.js';
import {sparse} from './scripting/sparse.js';
import {
    switchOutput,
    execute,
    rolling,
    notes,
    steps,
    prob,
    cond
} from './scripting/lang.js';

class SparseEffect extends ScriptingEffect {
    constructor(track) {
        super("Sparse", track);
        this.clear();

        this.numberOfOutputs = 2;
        this.newVar('density', 1, 0, 1);
    }

    clear() {
        this.myScript = pipe(
            sparse(this.var('density')));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new SparseEffect(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default SparseEffect;
